const utils = {
  api: "https://mindicador.cl/api",
  apiHistorical: "https://mindicador.cl/api/dolar",
  clpToUsd: "Ingresa monto en pesos chilenos que deseas convertir a dólares",
  usdToClp: "Ingresa monto en dólares que deseas convertir a pesos chilenos",
  //Error messages
  onlyNumbers: "Por favor usa sólo números",
};

export default utils;
